import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { MaterialsResellerPage } from "@/modules/material/pages/MaterialsReseller.page";

const materialsResellerSearchSchema = z.object({
	page: z.coerce.number().int().min(1).optional().default(1),
	query: z.string().optional(),
});

export const Route = createFileRoute("/__authed/m/materials/reseller")({
	validateSearch: (search) => materialsResellerSearchSchema.parse(search),
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_materials_reseller")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const search = Route.useSearch();
	const navigate = Route.useNavigate();

	return (
		<MaterialsResellerPage
			search={search}
			onSearchChange={(nextSearch, options) => {
				const resolvedQuery = Object.prototype.hasOwnProperty.call(nextSearch, "query")
					? nextSearch.query
					: search.query;

				navigate({
					replace: options?.replace,
					search: {
						page: nextSearch.page ?? search.page,
						query: resolvedQuery,
					},
				});
			}}
		/>
	);
}
